export function mergeNotificationRows<Row extends {id:number}>(rows:Row[],incoming:Row[]):Row[] {
  return [...new Map([...rows,...incoming].map(row => [row.id,row])).values()].sort((left,right) => right.id-left.id);
}
const notificationDate=new Intl.DateTimeFormat('he-IL',{timeZone:'Asia/Jerusalem',day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'});
export const notificationDateLabel=(value:string) => notificationDate.format(new Date(value));